var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.99 0L12 10.06L3.01 0L0 2.58L12 16L24 2.58L20.99 0Z"}));
}

ChevronDown.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16","fill":"currentColor"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
